export const skills = [
  {
    heading: "Technologies I've used recently",
    description:
      "Vue.js • React.js • Node.js • (S)CSS • Java • Python • C • SQL • MATLAB • Adobe XD • Git • Unity",
    icon: "code"
  },
  {
    heading: "Things I enjoy",
    description:
      "🎨 Drawing • 📷 Photography • 🗺️ Travelling • 🎲 Board Games • 👾 Game Dev • 🎾 Tennis • 🧗‍♀️ Rock Climbing",
    icon: "robot"
  }
];

export const education = [
  {
    heading: "University of Queensland (UQ)",
    link: "https://www.uq.edu.au/",
    description: [
      "🤖 Bachelor of Engineering Honours (mechatronics extended major)  &&  👩‍💻 Bachelor of Information Technology (software design major)"
    ],
    place: "Brisbane, Australia",
    dates: "2016 – mid 2021",
    grade: "First Class Honours, GPA: 6.7 / 7",
    imageLink: require("@/assets/images/uq.jpg")
  },
  {
    heading: "Korea Advanced Institute of Science and Technology (KAIST)",
    link: "https://www.kaist.ac.kr/en/",
    description: ["Semester Exchange Program"],
    place: "Daejeon, South Korea",
    dates: "Fall semester 2019",
    imageLink: require("@/assets/images/kaist.png")
  }
];

export const awards = [
  {
    year: "2021",
    list: [
      "UQ Class of 2021 Future Leaders Program",
      "UQ Employability Award",
      "Hawken & Prentice Scholar in the UQ EAIT Scholars Program for entire degree (top 5% of cohort)",
      "Dean’s Commendation for Academic Excellence Sem 1"
    ]
  },
  {
    year: "2020",
    list: [
      "UQ Ventures Virtual Hackathon - First Place",
      "KWM Transform Law Prize - First Place",
      "Ventures Validate program - Fourth Place",
      "Dean’s Commendation for Academic Excellence Sem 1 & 2"
    ]
  },
  {
    year: "2019",
    list: [
      "Rio Tinto Excellence Women in Engineering Scholarship",
      "Australian Government New Colombo Plan Scholarship (South Korea)",
      "Dean’s Commendation for Academic Excellence Sem 1"
    ]
  },
  {
    year: "2018",
    list: [
      "UQ Summer Research Scholarship",
      "UQ Ventures Shanghai Startup Adventure",
      "ICT Alumni Advantage Scholarship"
    ]
  },
  {
    year: "2017",
    list: [
      "ICT Alumni Advantage Scholarship",
      "John’s Residential Engineering Scholarship",
      "Australian Government New Colombo Plan Mobility Grant",
      "Dean’s Commendation for Academic Excellence Sem 1"
    ]
  },
  {
    year: "2016",
    list: [
      "John’s Residential Engineering Scholarship",
      "UQ Academic Excellence Scholarship"
    ]
  }
];

export const volunteering = [
  {
    info: "UQ Mechatronics and Robotics Society Technical Officer",
    date: "2020 - 2021"
  },
  {
    info: "UQ Women in Engineering Student Leader",
    date: "2020"
  },
  {
    info: "UQ New Colombo Plan Alumni Ambassador",
    date: "2020"
  },
  {
    info: "UQ ITEE Student Consultative Committee Member",
    date: "2018"
  },
  {
    info: "UQ Science and Engineering Challenge Event Staff",
    date: "2018"
  }
];
